import { render, staticRenderFns } from "./cyj-detail.vue?vue&type=template&id=7fe36a1c&scoped=true&"
import script from "./cyj-detail.vue?vue&type=script&lang=js&"
export * from "./cyj-detail.vue?vue&type=script&lang=js&"
import style0 from "./cyj-detail.vue?vue&type=style&index=0&id=7fe36a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe36a1c",
  null
  
)

export default component.exports